module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cfWmv"))).then(() => parcelRequire('37nVf'));